export default function withoutRef(v){

    // Object assign is not enough for multidimensional objects

    return JSON.parse(JSON.stringify(v));
}
